import React from 'react';
import ReactDOM from 'react-dom';
import UPshowState from '../UPshowState';
import StateFactory from '../StateFactory';
import ScreenService from '../../services/ScreenService';
import SettingsService from '../../services/SettingsService';
import ScheduledContentComponent from './ScheduledContentComponent';
import hasScheduledLiveContent from './hasScheduledLiveContent';

const BARLOW_FAMILY = 'Barlow Condensed';

async function loadBarlowCondensed() {
    // Relies on the @font-face declaration in index.scss; document.fonts.load()
    // is idempotent and waits until the face is fully downloaded and ready.
    // Resolves to [] (not rejected) when the face is not found — check the result.
    const loaded = await document.fonts.load(`italic 800 1px "${BARLOW_FAMILY}"`);
    if (!loaded.length) {
        console.warn('[ScheduledContentState] Barlow Condensed not found, using fallback font.');
    }
}

class ScheduledContentState extends UPshowState {

    get name() {
        return 'scheduled_content';
    }

    async preload() {
        try {
            await loadBarlowCondensed();
        } catch (err) {
            console.warn('[ScheduledContentState] Barlow Condensed failed to load, using fallback font.', err);
        }
        ReactDOM.render(<ScheduledContentComponent />, this.node);
        return super.preload();
    }

    static appliesTo() {
        return !ScreenService.isVertical && hasScheduledLiveContent();
    }

}

StateFactory.register('empty_state', ScheduledContentState, 1);

export default ScheduledContentState;
